// Canonical Mental Skills (ASCI-28) subscale definitions shared by the
// read-only athlete card and the admin profile section.
//
// Mirrors backend/app/services/mental_skills.py SUBSCALES (order preserved for
// display). Each subscale is 4 items on a 0..3 Likert → max 12; composite = 84.
// A backend subscale change should only edit this file.

export const MENTAL_SKILLS_SUBSCALES = [
  { key: 'coping_with_adversity',  label: 'Coping with Adversity' },
  { key: 'peaking_under_pressure', label: 'Peaking Under Pressure' },
  { key: 'goal_setting',           label: 'Goal Setting' },
  { key: 'concentration',          label: 'Concentration' },
  { key: 'freedom_from_worry',     label: 'Freedom from Worry' },
  { key: 'confidence',             label: 'Confidence' },
  { key: 'coachability',           label: 'Coachability' },
];

export const MENTAL_SKILLS_SUBSCALE_MAX = 12;
export const MENTAL_SKILLS_TOTAL_MAX = 84;
